// extracted by mini-css-extract-plugin
module.exports = {"buttons":"a10a3f92e9--buttons--QbT_Z"};